import Vue from 'vue/dist/vue.esm'
import VueResource from 'vue-resource';
import vClickOutside from 'v-click-outside'

Vue.use(VueResource);
Vue.use(vClickOutside)

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.querySelector('#notifications');
  if (!rootElement) {return}
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  if (csrfToken) {
    Vue.http.headers.common['X-CSRF-Token'] = csrfToken;
  }

  new Vue({
    el: rootElement,
    data: {
      companies: [],
      notifications: [],
      showNotifications: false,
      unreadCount: 0,
      expandedId: null
    },
    mounted() {
      this.loadNotifications();

      const timerId = setInterval(this.loadNotifications, 15000);

      // stop getting new notifications after 5 minutes
      setTimeout(() => clearInterval(timerId), 300000);
    },
    methods: {
      closeNotificationWindow() {
        setTimeout(() => {
          this.showNotifications = false;
        }, 450);
      },

      triggerNotificationWindow() {
        if (this.companies.length > 0) {
          this.expandedId = this.companies[0].id;
        }

        if (!this.showNotifications && this.unreadCount > 0) {
          const notificationIds = this.getUnreadNotificationIds();
          if (notificationIds.length > 0) {
            this.markRead(notificationIds);
          }
        }

        this.showNotifications = !this.showNotifications;
      },

      getUnreadNotificationIds() {
        if (this.notifications.length > 0) {
          return this.notifications.map(n => n.id);
        }
        const company = this.companies.find(c => c.id === this.expandedId);
        return company ? company.notifications.map(n => n.id) : [];
      },

      loadNotifications() {
        this.$http.get('/notifications').then(
            response => {
              const { unread_count, notifications, companies } = response.body;
              this.unreadCount = unread_count;
              this.notifications = notifications;
              this.companies = companies;
            },
            error => {
              console.error('Failed to load notifications:', error.body?.error || error);
              // Optionally show UI error message here
            }
        );
      },

      itemClass(isRead) {
        return isRead ? '' : 'unread';
      },

      companyClass(id) {
        return this.expand_get(id) ? '' : 'closed'
      },

      markRead(ids) {
        this.$http.put(`/notifications/mark_read`, {notification_ids: ids}).then(response => {
        }, response => {})
      },

      expand_get(id) {
        return this.expandedId === id
      },

      expand_set(id) {
        if (this.expandedId === id) {
          this.expandedId = null;
        } else {
          this.expandedId = id;
          let notification_ids = this.companies.find ( c => c.id === this.expandedId).notifications.map(n => n.id)
          this.markRead(notification_ids)
        }
      },
    }
  })
});